<ng-container *ngIf="linkItem">
  <ng-container
    *ngIf="
      linkItem.external ||
        linkItem.link?.startsWith('http') ||
        linkItem.pdf?.url?.startsWith('http') ||
        isLinkMailTo;
      else relative
    "
  >
    <a
      class="{{ class }}"
      [ngClass]="{ internal: !linkItem.external }"
      [href]="linkItem.link ? linkItem.link : linkItem.pdf?.url"
      [target]="target"
      (click)="$event.preventDefault(); linkClicked.emit($event); $event.target && onLinkClicked($event);"
    >
      <img
        *ngIf="linkItem.imageUrl"
        src="{{ linkItem.imageUrl }}"
        alt="{{ linkItem.name }}"
      />
      <span
        *ngIf="!linkItem.imageUrl"
        [innerHtml]="linkItem.name | safeHtml: SanitizerValueType.HTML"
        (click)="$event.preventDefault();"
      ></span>
    </a>
  </ng-container>

  <ng-template #relative>
    <ng-container
      *ngIf="
        linkItem.link?.substr(-4, 1) === '.' ||
          linkItem.link?.substr(-5, 1) === '.' ||
          newTab === true;
        else routerLink
      "
    >
      <a
        class="internal {{ class }}"
        [routerLink]="(startsWithSlash ? '' : '/') + linkItem.link"
        [fragment]="linkItem.fragment"
        target="_blank"
        (click)="
          $event.preventDefault();
          linkClicked.emit($event);
          $event.target && onLinkClicked($event)
        "
      >
        <img
          *ngIf="linkItem.imageUrl"
          src="{{ linkItem.imageUrl }}"
          alt="{{ linkItem.name }}"
        />
        <span
          *ngIf="!linkItem.imageUrl"
          [innerHtml]="linkItem.name | safeHtml: SanitizerValueType.HTML"
        ></span>
      </a>
    </ng-container>
  </ng-template>
  <ng-template #routerLink>
    <a
      class="{{ class }}"
      [routerLink]="(startsWithSlash ? '' : '/') + linkItem.link"
      [fragment]="linkItem.fragment"
      [target]="target"
      (click)="
        $event.preventDefault();
        linkClicked.emit($event);
        $event.target && onLinkClicked($event)
      "
    >
      <img
        *ngIf="linkItem.imageUrl"
        src="{{ linkItem.imageUrl }}"
        alt="{{ linkItem.name }}"
      />
      <span
        *ngIf="!linkItem.imageUrl"
        [innerHtml]="linkItem.name | safeHtml: SanitizerValueType.HTML"
      ></span>
    </a>
  </ng-template>
</ng-container>
